// @ts-check

import { api } from '@/api'
import { toCamelCase, toSnakeCase } from '@/helpers/formatters'

export const getPurchaseInvoiceEmail = async () =>
  api.get('settings/purchase-invoice/emails')

export const getPurchaseInvoiceEInvoiceAddress = async () =>
  api.get('settings/purchase-invoice/e-invoice')

export const getPurchaseInvoicePaperAddress = async () =>
  api.get('settings/purchase-invoice/paper-invoice')

/**
 * @returns {Promise<BookkeepingResignation[]>}
 */
export const getBookkeepingResignations = async () => {
  const { data: resignations } = await api.get(
    'bookkeeping-agency-resignations'
  )

  return toCamelCase(resignations)
}

/**
 * @param {BookkeepingResignation} payload
 * @returns {Promise<BookkeepingResignation>}
 */
export const createBookkeepingResignation = async (payload) => {
  const { data: resignation } = await api.post(
    'bookkeeping-agency-resignations',
    toSnakeCase(payload)
  )

  return toCamelCase(resignation)
}

/**
 * @param {BookkeepingResignation} payload
 * @returns {Promise<BookkeepingResignation>}
 */
export const updateBookkeepingResignation = async ({ id, ...payload }) => {
  const { data: resignation } = await api.patch(
    `bookkeeping-agency-resignations/${id}`,
    toSnakeCase(payload)
  )

  return toCamelCase(resignation)
}

export const setUserLanguage = async (language) =>
  api.patch('user/language', { language })

export const addCouponCode = async (code) =>
  api.post(`coupon-codes/${code}/apply`)

export const settingApi = {
  getPurchaseInvoiceEmail,
  getPurchaseInvoiceEInvoiceAddress,
  getPurchaseInvoicePaperAddress,
  getBookkeepingResignations,
  createBookkeepingResignation,
  updateBookkeepingResignation,
  setUserLanguage,
  addCouponCode
}
